import { useLazyQuery } from 'providers/tanstack-query/useLazyQuery'
import { fromDTO } from './api/mapper'
import { GET_VIEWPORTS } from './api/query'
import { Data, Variables, ViewportSliceDTO } from './api/types'
import { Props, UseGetViewports, ViewportSlice } from './types'

export const useGetViewports = ({ filters, sort, workspaceId }: Props): UseGetViewports => {
  const { isLoading, lazyFetch } = useLazyQuery<Variables, Data, ViewportSlice[]>({
    options: {
      select: ({ viewports: { nodes } }: Data): ViewportSlice[] =>
        nodes?.map((node: ViewportSliceDTO): ViewportSlice => fromDTO(node)) ?? [],
    },
    query: GET_VIEWPORTS,
    variables: {
      sort,
      terms: filters,
      workspaceId,
    },
  })

  const lazyGetViewports = async (): Promise<ViewportSlice[]> => {
    return (await lazyFetch()).data ?? []
  }

  return {
    lazyGetViewports,
    loading: isLoading,
  }
}
